module.exports = __webpack_public_path__ + "img/li1.d8c4daaa.png";